import type { ExtractPropTypes, PropType } from 'vue'
import type { OptionValue                } from '../../../constants'
import type _Tabs                          from './tabs.vue'

import { optionValue } from '../../../constants'
import { tabsProps   } from 'element-plus'

export const sdTabsProps = {
    ...tabsProps,
    
    // 扩展属性
    options : { type: Array  as PropType<OptionValue[]>, default: () => []          }, // 选项列表
    prop    : { type: Object as PropType<OptionValue>  , default: () => optionValue }, 

} as const

export type SdTabsProps    = ExtractPropTypes<typeof sdTabsProps>
export type SdTabsInstance = InstanceType<typeof _Tabs>


